import React, { useMemo, useState, useEffect, useRef } from "react";
import { useCart } from "./CartContext";
import CityPicker from "./CityPicker";
import emailjs from "@emailjs/browser";
import logo from "../../image/logotype/logo.svg";
import logo1 from "../../icons/icons8-success.svg";
import Footer from "../Footer/Footer";
import MaskedInput from 'react-text-mask'
import { Link } from "react-router-dom";
import "./cart.scss";

// === NEW: промокоди та ключ НП ==========================
const PROMOS = {
    SUN5: 5,
    SUN10: 10,
    SUN15: 15,
    wegwe4rgh45erh: 1,
};
const NP_KEY = "92b6f560ed7fd3572193becd8d3b26e1";
// ========================================================

export default function CheckoutPage() {
    const { items, totalQty, totalSum, inc, dec, remove, clear } = useCart();

    const [form, setForm] = useState({
        name: "",
        phone: "",
        email: "",
        city: "",
        cityRef: "",      // ← потрібен для НП відділень
        delivery: "Самовивіз з Нової Пошти",
        warehouse: "",
        comment: "",
        callMe: true,
        payment: "Безготівковий розрахунок",
    });

    // === NEW: валідація ==========================
    const [errors, setErrors] = useState({});
    const firstErrorRef = useRef(null);
    const validate = () => {
        const e = {};

        const phoneRe = /^\+38\s?\(?0\d{2}\)?\s?\d{3}\s?\d{2}\s?\d{2}$/; // +38 0XX XXX XX XX
        if (!form.name.trim()) e.name = "Вкажіть ПІБ";
        if (!phoneRe.test(form.phone.trim())) e.phone = "Телефон у форматі +38 0XX XXX XX XX";
        if (!form.city.trim()) e.city = "Вкажіть місто";
        if (!form.warehouse.trim()) e.warehouse = "Вкажіть відділення / адресу";
        if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Невірний email";

        setErrors(e);
        return e;
    };
    // =============================================

    // === NEW: інлайн-промокод =====================
    const [showPromo, setShowPromo] = useState(false);
    const [promoInput, setPromoInput] = useState("");
    const [appliedPromo, setAppliedPromo] = useState(null);
    const [promoMsg, setPromoMsg] = useState("");
    const [agree, setAgree] = useState(false);
    const [showAgreement, setShowAgreement] = useState(false);
    const [agreementError, setAgreementError] = useState("");
    const [success, setSuccess] = React.useState(false);
    const [successSum, setSuccessSum] = React.useState(0);
    const isNovaPoshta = form.delivery === "Самовивіз з Нової Пошти";


    const applyPromo = () => {
        const code = promoInput.trim().toUpperCase();
        const p = PROMOS[code];
        if (!p) {
            setPromoMsg("Промокод не знайдено");
            setAppliedPromo(null);
        } else {
            setAppliedPromo({ code, percent: p });
            setPromoMsg(`Знижка ${p}% застосована`);
        }
    };
    const discount = appliedPromo ? Math.round((totalSum * appliedPromo.percent) / 100) : 0;
    const toPay = Math.max(0, totalSum - discount);
    // =============================================

    // === NEW: підказки відділень Нової Пошти =====
    const [wareQuery, setWareQuery] = useState("");
    const [wareSuggest, setWareSuggest] = useState([]);
    const [loadingWare, setLoadingWare] = useState(false);

    useEffect(() => {
        const q = wareQuery.trim();

        // якщо НЕ Самовивіз з Нової Пошти — не виконуємо жодних запитів і чистимо підказки
        if (!isNovaPoshta) {
            setWareSuggest([]);
            return;
        }

        if (!form.city || q.length < 1) {
            setWareSuggest([]);
            return;
        }

        const id = setTimeout(async () => {
            try {
                setLoadingWare(true);
                const res = await fetch("https://api.novaposhta.ua/v2.0/json/", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        apiKey: NP_KEY,
                        modelName: "AddressGeneral",
                        calledMethod: "getWarehouses",
                        methodProperties: {
                            CityName: form.city,
                            FindByString: q,
                            Limit: 10,
                            Language: "UA",
                        },
                    }),
                });
                const data = await res.json();
                const list = (data?.data || []).map((w) => ({
                    id: w.Ref,
                    text: `${w.Description} (${w.Number})`,
                }));
                setWareSuggest(list);
            } catch {
                setWareSuggest([]);
            } finally {
                setLoadingWare(false);
            }
        }, 400);

        return () => clearTimeout(id);
    }, [isNovaPoshta, form.city, wareQuery]);

    useEffect(() => {
        if (!isNovaPoshta) {
            setWareQuery("");
            setWareSuggest([]);
            setForm(f => ({ ...f, warehouse: "" }));
        }
    }, [isNovaPoshta]);

    useEffect(() => {
        if (isNovaPoshta) {
            setWareQuery("");
            setWareSuggest([]);
            setForm(f => ({ ...f, warehouse: "" }));
        }
    }, [form.city, isNovaPoshta]);
    // =============================================


    const orderNo = useMemo(() => `SU-${Date.now().toString().slice(-6)}`, []);

    const onChange = (e) => {
        const { name, type, checked, value } = e.target;
        setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
        setErrors((prev) => ({ ...prev, [name]: undefined }));
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        if (!agree) {
            setAgreementError("Щоб оформити замовлення, потрібно прийняти умови угоди користувача.");
            document.querySelector(".agreement")?.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
            return;
        }

        const eMap = validate();
        const hasErrors = Object.keys(eMap).length > 0;
        if (hasErrors) {
            // прокрутка до першої помилки
            const firstKey = Object.keys(eMap)[0];
            firstErrorRef.current?.querySelector(`[name="${firstKey}"]`)?.focus();
            return;
        }

        const templateParams = {
            orderNo,
            name: form.name,
            phone: form.phone,
            email: form.email,
            city: form.city,
            delivery: form.delivery,
            warehouse: form.warehouse,
            payment: form.payment,
            comment: form.comment,
            callMe: form.callMe ? "Так" : "Ні",

            // кількість позицій
            totalQty,

            // ↓↓↓ нові ключі, яких чекає шаблон листа ↓↓↓
            subtotal: totalSum.toLocaleString("uk-UA"),
            discountPercent: appliedPromo ? appliedPromo.percent : 0,
            discountAmount: discount.toLocaleString("uk-UA"),
            promoCode: appliedPromo ? appliedPromo.code : "—",
            totalAfter: toPay.toLocaleString("uk-UA"),
            // ↑↑↑ нові ключі

            // перелік позицій
            items: items
                .map(
                    (i) =>
                        `• ${i.title} — ${i.unit}, ${i.quantity} шт × ${i.price.toLocaleString("uk-UA")} ₴`
                )
                .join("\n"),

            // (необов’язково) залиш для зворотної сумісності
            totalSum: toPay.toLocaleString("uk-UA"),
            promo: appliedPromo ? `${appliedPromo.code} (-${appliedPromo.percent}%)` : "—",
        };

        try {
            await emailjs.send(
                "service_c5tpsci",
                "template_o73oweq",
                templateParams,
                "HT8d_t5T7MkEYpLIh"
            );
            setSuccessSum(toPay);
            setSuccess(true);
        } catch (err) {
            console.error(err);
        }
    };

    if (!items.length && !success) {
        return (
            <section className="emptyCart">
                <div className="emptyCart__card">
                    <div className="emptyCart__icon" aria-hidden>🛒</div>
                    <h1 className="emptyCart__title">Кошик порожній</h1>
                    <p className="emptyCart__text">
                        Додайте товари до кошика, щоб оформити замовлення. Якщо потрібна
                        підказка — скористайтеся пошуком або перегляньте акційні пропозиції.
                    </p>

                    <div className="emptyCart__actions">
                        <Link to="/" className="btn-primary">На головну</Link>
                        <Link to="/catalog" className="btn-outline">Перейти в каталог</Link>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <>
            <div className="checkout">
                <div className="checkout__left" ref={firstErrorRef}>
                    <div className="checkout__order">
                        <img className="checkout__logo" src={logo} alt="Sunberry Ukraine" />
                        <h1 className="h1">Оформлення замовлення</h1>
                    </div>
                    <form onSubmit={onSubmit} className="checkout__form">
                        {/* ПІБ */}
                        <label className={`field ${errors.name ? "is-error" : ""}`}>
                            <span>ПІБ</span>
                            <input name="name" value={form.name} onChange={onChange} />
                            {errors.name && <small className="field__err">{errors.name}</small>}
                        </label>

                        {/* Телефон */}
                        <label className={`field ${errors.phone ? "is-error" : ""}`}>
                            <span>Телефон</span>
                            <MaskedInput
                                className="field__input-phone"
                                mask={['+', '3', '8', ' ', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]}
                                pattern="^\+[0-9]{2}\s\((\d+)\)\s\d{3}\s\d{2}\s\d{2}"
                                name="phone"
                                placeholder="номер телефону"
                                required
                                value={form.phone}
                                onChange={(e) => onChange(e)}
                            />
                            {errors.phone && <small className="field__err">{errors.phone}</small>}
                        </label>

                        {/* Місто + кнопка Обрати (залишаємо обидва варіанти) */}
                        <div className="field field--row">
                            <label className="field">
                                <span>Місто</span>
                                <CityPicker
                                    value={form.city}
                                    onChange={(str) => setForm((f) => ({ ...f, city: str }))} // друк
                                    onPick={({ name, ref }) => {
                                        // вибір зі списку
                                        setForm((f) => ({ ...f, city: name, cityRef: ref }));
                                    }}
                                />

                            </label>

                        </div>

                        {/* E-mail (необов’язково) */}
                        <label className={`field ${errors.email ? "is-error" : ""}`}>
                            <span>Eлектронна пошта</span>
                            <input name="email" type="email" value={form.email} onChange={onChange} />
                            {errors.email && <small className="field__err">{errors.email}</small>}
                        </label>

                        {/* Коментар */}
                        <label className="field">
                            <span>Коментар</span>
                            <textarea name="comment" rows={4} value={form.comment} onChange={onChange} />
                        </label>

                        {/* Доставка / Відділення */}
                        <div className="field field--row">
                            <label className="field">
                                <span>Доставка</span>
                                <select name="delivery" value={form.delivery} onChange={onChange}>
                                    <option>Самовивіз з Нової Пошти</option>
                                    <option>Кур'єр Нової Пошти</option>
                                    <option>Самовивіз з наших магазинів</option>
                                    <option>Укрпошта Стандарт до відділення</option>
                                    <option>Укрпошта Стандарт кур'єром</option>
                                    <option>Укрпошта Експрес до відділення</option>
                                    <option>Укрпошта Експрес кур'єром</option>
                                </select>
                            </label>
                            <label className={`field ${errors.warehouse ? "is-error" : ""}`}>
                                <span>Відділення / Адреса</span>
                                <input
                                    name="warehouse"
                                    placeholder="№, адреса"
                                    value={form.warehouse}
                                    onChange={(e) => {
                                        onChange(e);
                                        if (isNovaPoshta) setWareQuery(e.target.value);
                                    }}
                                    autoComplete="off"
                                />
                                {/* NEW: підказки НП */}
                                {isNovaPoshta && !!wareSuggest.length && (
                                    <ul className="suggest">
                                        {wareSuggest.map((w) => (
                                            <li
                                                key={w.id}
                                                onClick={() => {
                                                    setForm((f) => ({ ...f, warehouse: w.text }));
                                                    setWareSuggest([]);
                                                    setWareQuery("");
                                                }}
                                            >
                                                {w.text}
                                            </li>
                                        ))}
                                    </ul>
                                )}

                                {isNovaPoshta && loadingWare && (
                                    <div className="suggest suggest--loading">Завантаження…</div>
                                )}
                            </label>
                        </div>

                        {/* Оплата */}
                        <label className="field">
                            <span>Оплата</span>
                            <select name="payment" value={form.payment} onChange={onChange}>
                                <option>Оплата під час отримання товару</option>
                                <option>Безготівковий розрахунок для юридичної особи</option>
                                <option>Безготівковий розрахунок для фізичної особи</option>
                                <option>Оплата зараз по реквізитам IBAN</option>
                            </select>
                        </label>

                        {/* Не телефонувати */}
                        <label className="checkbox">
                            <input
                                type="checkbox"
                                name="callMe"
                                checked={form.callMe}
                                onChange={onChange}
                            />
                            <span>Бажаю отримувати новини та спеціальні пропозиції магазину</span>
                        </label>
                    </form>
                </div>

                <aside className="checkout__aside">
                    <div className="promoBar">

                        {!showPromo ? (
                            <span className="promoBar__label" onClick={() => {
                                setShowPromo((v) => !v);
                            }}>Промокод</span>
                        ) : (
                            <div className="promoInline" role="region" aria-label="Промокод">
                                <input
                                    placeholder="введіть промокод"
                                    value={promoInput}
                                    onChange={(e) => setPromoInput(e.target.value)}
                                />
                                <button type="button" className="btn-primary" onClick={applyPromo}>
                                    Застосувати
                                </button>
                                <button
                                    type="button"
                                    className="promoBar__toggle"
                                    onClick={() => {
                                        setShowPromo((v) => !v);
                                    }}
                                >
                                    {showPromo ? "Закрити" : "➕ Додати"}
                                </button>
                            </div>
                        )}


                        {promoMsg && <small className="promoInline__msg">{promoMsg}</small>}
                    </div>

                    <div className="summary">
                        <h3>Ваше замовлення</h3>

                        <ul className="summary__list">
                            {items.map((i) => (
                                <li key={i.sku} className="summary__row">
                                    <img
                                        src={i.img || "/placeholder.jpg"}
                                        alt={i.title}
                                        className="summary__img"
                                    />
                                    <div className="summary__title">
                                        <div className="summary__name">{`${i.title}, ${i.unit}`}</div>
                                        <small className="summary__sku">Артикул: {i.sku}</small>
                                    </div>

                                    <div className="summary__qty">
                                        <button onClick={() => dec(i.sku)}>-</button>
                                        <span>{i.quantity}</span>
                                        <button onClick={() => inc(i.sku)}>+</button>
                                    </div>

                                    <div className="summary__sum">
                                        {(i.price * i.quantity).toLocaleString("uk-UA")} ₴
                                    </div>

                                    <button className="summary__remove" onClick={() => remove(i.sku)} aria-label="Видалити">
                                        🗑️
                                    </button>
                                </li>
                            ))}
                        </ul>

                        <div className="summary__meta">
                            <div className="summary__line">
                                <span>Доставка</span>
                                <b>за тарифами перевізника</b>
                            </div>

                            <div className="summary__line">
                                <span>Сума товарів</span>
                                <b>{totalSum.toLocaleString("uk-UA")} ₴</b>
                            </div>

                            {discount > 0 && (
                                <div className="summary__line summary__line--discount">
                                    <span>Знижка {appliedPromo.percent}%</span>
                                    <b>− {discount.toLocaleString("uk-UA")} ₴</b>
                                </div>
                            )}

                            <div className="summary__total">
                                Всього до сплати: <b>{toPay.toLocaleString("uk-UA")} ₴</b>
                            </div>

                            <div className="summary__orderNo">
                                № замовлення: <b>{orderNo}</b>
                            </div>
                        </div>
                        <div className={`agreement ${agreementError ? "agreement--error" : ""}`}>
                            <label className="agreement__check checkbox">
                                <input
                                    type="checkbox"
                                    checked={agree}
                                    onChange={(e) => {
                                        setAgree(e.target.checked);
                                        if (e.target.checked) setAgreementError("");
                                    }}
                                />
                                <span className="agreement__text">
                                    Підтверджуючи замовлення, я приймаю умови
                                    <button
                                        type="button"
                                        className="agreement__link"
                                        onClick={() => setShowAgreement(true)}
                                    >
                                        угоди користувача
                                    </button>
                                </span>
                            </label>

                            {!agree && !agreementError && (
                                <div className="agreement__hint">
                                    Перед оформленням замовлення потрібно підтвердити згоду з умовами.
                                </div>
                            )}

                            {agreementError && (
                                <div className="agreement__error">
                                    {agreementError}
                                </div>
                            )}
                        </div>

                        <button className="btn-primary btn-primary--full" onClick={onSubmit}>
                            Оформити замовлення
                        </button>
                    </div>
                    <AgreementModal open={showAgreement} onClose={() => setShowAgreement(false)} />
                </aside>
                {success && (
                    <div className="modal successModal" role="dialog" aria-modal="true" aria-labelledby="sm-title">
                        <div className="modal__backdrop" onClick={closeSuccess} />
                        <div className="modal__card">
                            <button className="modal__close" onClick={closeSuccess} aria-label="Закрити">✕</button>

                            <div className="successModal__icon" aria-hidden>
                                <img src={logo1} alt="success" />
                            </div>
                            <h2 id="sm-title" className="successModal__title">Замовлення відправлено</h2>

                            <p className="successModal__text">
                                Дякуємо за покупку! Наш менеджер зв’яжеться з вами найближчим часом для підтвердження деталей.
                            </p>

                            <div className="successModal__summary">
                                <div><span>Сума до сплати: </span><b>{successSum.toLocaleString("uk-UA")} ₴</b></div>
                                <div><span>№ замовлення: </span><b>{orderNo}</b></div>
                            </div>

                            <div className="successModal__actions">
                                <Link to="/"><button className="btn-primary" onClick={closeSuccess}>На головну</button></Link>
                                <Link to="/catalog"><button className="btn-outline" onClick={closeSuccess}>Продовжити покупки</button></Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </>
    );

    function closeSuccess() {
        setSuccess(false);
        clear();
    }

    function AgreementModal({ open, onClose }) {
        useEffect(() => {
            document.body.style.overflow = open ? "hidden" : "";
            return () => (document.body.style.overflow = "");
        }, [open]);

        if (!open) return null;

        return (
            <div className="modal" aria-modal="true" role="dialog">
                <div className="modal__backdrop" onClick={onClose} />
                <div className="modal__dialog">
                    <button className="modal__close" onClick={onClose} aria-label="Закрити">×</button>
                    <h3 className="modal__title">
                        Положення про обробку і захист персональних даних у базах персональних даних,
                        володільцем яких є продавець
                    </h3>
                    <div className="modal__scroll">
                        <div className="modal__content">
                            <h4>Зміст</h4>
                            <ol>
                                <li className="modal__content--text">Загальні поняття та сфера застосування</li>
                                <li className="modal__content--text">Перелік баз персональних даних</li>
                                <li className="modal__content--text">Мета обробки персональних даних</li>
                                <li className="modal__content--text">Порядок обробки персональних даних: отримання згоди, повідомлення про права та дії з персональними даними суб’єкта персональних даних</li>
                                <li className="modal__content--text">Місцезнаходження бази персональних даних</li>
                                <li className="modal__content--text">Умови розкриття інформації про персональні дані третім особам</li>
                                <li className="modal__content--text">Захист персональних даних: способи захисту, відповідальна особа, працівники, які безпосередньо здійснюють обробку та/або мають доступ до персональних даних у зв’язку з виконанням своїх службових обов’язків, строк зберігання персональних даних</li>
                                <li className="modal__content--text">Права суб’єкта персональних даних</li>
                                <li className="modal__content--text">Порядок роботи з запитами суб'єкта персональних даних</li>
                                <li className="modal__content--text">Державна реєстрація бази персональних даних</li>
                            </ol>
                            <div className="modal__content__inner"></div>
                            <h4>1. Загальні поняття та сфера застосування</h4>
                            <p className="modal__content--indent">
                                1.1. Визначення термінів:
                            </p>
                            <p className="modal__content--indent">
                                <strong>База персональних даних</strong> — іменована сукупність упорядкованих персональних даних в електронній формі та/або у формі картотек персональних даних;
                            </p>
                            <p className="modal__content--indent">
                                <strong>Відповідальна особа</strong> — визначена особа, яка організовує роботу, пов’язану із захистом персональних даних при їх обробці, відповідно до закону;
                            </p>
                            <p className="modal__content--indent">
                                <strong>Володілець бази персональних даних</strong> — фізична або юридична особа, якій законом або за згодою суб’єкта персональних даних надано право на обробку цих даних, яка затверджує мету обробки персональних даних у цій базі даних, встановлює склад цих даних та процедури їх обробки, якщо інше не визначено законом;
                            </p>
                            <p className="modal__content--indent">
                                <strong>Державний реєстр баз персональних даних</strong> — єдина державна інформаційна система збору, накопичення та обробки відомостей про зареєстровані бази персональних даних;
                            </p>
                            <p className="modal__content--indent">
                                <strong>загальнодоступні джерела персональних даних</strong> —  довідники, адресні книги, реєстри, списки, каталоги, інші систематизовані збірники відкритої інформації, які містять персональні дані, розміщені та опубліковані з відома суб’єкта персональних даних. Не вважаються загальнодоступними джерелами персональних даних соціальні мережі та інтернет-ресурси, в яких суб’єкт персональних даних залишають свої персональні дані (окрім випадків, коли суб’єктом персональних даних прямо зазначено, що персональні дані розміщені з метою їх вільного поширення та використання);
                            </p>
                            <p className="modal__content--indent">
                                <strong>згода суб’єкта персональних даних</strong> — будь-яке документоване, добровільне волевиявлення фізичної особи щодо надання дозволу на обробку її персональних даних відповідно до сформульованої мети їх обробки;
                            </p>
                            <p className="modal__content--indent">
                                <strong>знеособлення персональних даних</strong> — вилучення відомостей, які дають змогу ідентифікувати особу;
                            </p>
                            <p className="modal__content--indent">
                                <strong>обробка персональних даних</strong> — будь-яка дія або сукупність дій, здійснених повністю або частково в інформаційній (автоматизованій) системі та/або в картотеках персональних даних, які пов’язані зі збиранням, реєстрацією, накопиченням, зберіганням, адаптуванням, зміною, поновленням, використанням і поширенням (розповсюдженням, реалізацією, передачею), знеособленням, знищенням відомостей про фізичну особу;
                            </p>
                            <p className="modal__content--indent">
                                <strong>персональні дані</strong> — відомості чи сукупність відомостей про фізичну особу, яка ідентифікована або може бути конкретно ідентифікована;
                            </p>
                            <p className="modal__content--indent">
                                <strong>розпорядник бази персональних даних</strong> — фізична чи юридична особа, якій володільцем бази персональних даних або законом надано право обробляти ці дані. Не є розпорядником бази персональних даних особа, якій володільцем та/або розпорядником бази персональних даних доручено здійснювати роботи технічного характеру з базою персональних даних без доступу до змісту персональних даних;
                            </p>
                            <p className="modal__content--indent">
                                <strong>суб’єкт персональних даних</strong> — фізична особа, стосовно якої відповідно до закону здійснюється обробка її персональних даних;
                            </p>
                            <p className="modal__content--indent">
                                <strong>третя особа</strong> — будь-яка особа, за винятком суб’єкта персональних даних, володільця чи розпорядника бази персональних даних та уповноваженого державного органу з питань захисту персональних даних, якій володільцем чи розпорядником бази персональних даних здійснюється передача персональних даних відповідно до закону;
                            </p>
                            <p className="modal__content--indent">
                                <strong>особливі категорії даних</strong> — персональні дані про расове або етнічне походження, політичні, релігійні або світоглядні переконання, членство в політичних партіях та професійних спілках, а також даних, що стосуються здоров’я чи статевого життя.
                            </p>
                            <p className="modal__content--indent">
                                1.2. Дане Положення обов’язкове для застосування відповідальною особою та співробітниками продавця, які безпосередньо здійснюють обробку та/або мають доступ до персональних даних у зв’язку з виконанням своїх службових обов’язків.
                            </p>
                            <div className="modal__content__inner">
                                <h4>2. Перелік баз персональних даних</h4>
                                <p className="modal__content--indent">
                                    2.1. Продавець є власником таких баз персональних даних:
                                </p>
                                <p className="modal__content--indent">
                                    — база персональних даних контрагентів.
                                </p>
                            </div>
                            <div className="modal__content__inner">
                                <h4>3. Мета обробки персональних даних</h4>
                                <p className="modal__content--indent">
                                    3.1. Метою обробки персональних даних у системі є забезпечення реалізації цивільно-правових відносин, надання, отримання та здійснення розрахунків за придбані товари та послуги відповідно до Податкового кодексу України, Закону України «Про бухгалтерський облік та фінансову звітність в Україні».
                                </p>
                            </div>
                            <div className="modal__content__inner">
                                <h4>4. Порядок обробки персональних даних: отримання згоди, повідомлення про права та дії з персональними даними суб’єкта персональних даних</h4>
                                <p className="modal__content--indent">
                                    4.1. Згода суб’єкта персональних даних має бути добровільним волевиявленням фізичної особи щодо надання дозволу на обробку її персональних даних відповідно до сформульованої мети їхньої обробки.
                                </p>
                                <p className="modal__content--indent">
                                    4.2. Згода суб’єкта персональних даних може бути надана у таких формах:
                                </p>
                                <p className="modal__content--indent">
                                    — документ на паперовому носії з реквізитами, що дає змогу ідентифікувати цей документ і фізичну особу;
                                </p>
                                <p className="modal__content--indent">
                                    — електронний документ, який має містити обов’язкові реквізити, що дають змогу ідентифікувати цей документ та фізичну особу. Добровільне волевиявлення фізичної особи щодо надання дозволу на обробку її персональних даних доцільно засвідчувати електронним підписом суб’єкта персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — відмітка на електронній сторінці документа чи в електронному файлі, що обробляється в інформаційній системі на основі документованих програмно-технічних рішень.
                                </p>
                                <p className="modal__content--indent">
                                    4.3. Згода суб’єкта персональних даних надається під час оформлення цивільно-правових відносин відповідно до чинного законодавства.
                                </p>
                                <p className="modal__content--indent">
                                    4.4. Повідомлення суб’єкта персональних даних про включення його персональних даних до бази персональних даних, права, визначені Законом України «Про захист персональних даних», мету збору даних та осіб, яким передаються його персональні дані здійснюється під час оформлення цивільно-правових відносин відповідно до чинного законодавства.
                                </p>
                                <p className="modal__content--indent">
                                    4.5. Обробка персональних даних про расове або етнічне походження, політичні, релігійні або світоглядні переконання, членство в політичних партіях та професійних спілках, а також даних, що стосуються здоров’я чи статевого життя (особливі категорії даних) забороняється.
                                </p>
                            </div>
                            <div className="modal__content__inner">
                                <h4>5. Місцезнаходження бази персональних даних</h4>
                                <p className="modal__content--indent">
                                    5.1. Вказані у розділі 2 цього Положення бази персональних даних знаходяться за адресою продавця.
                                </p>
                            </div>
                            <div className="modal__content__inner">
                                <h4>6. Умови розкриття інформації про персональні дані третім особам</h4>
                                <p className="modal__content--indent">
                                    6.1. Порядок доступу до персональних даних третіх осіб визначається умовами згоди суб'єкта персональних даних, наданої володільцю персональних даних на обробку цих даних, або відповідно до вимог закону.
                                </p>
                                <p className="modal__content--indent">
                                    6.1. Порядок доступу до персональних даних третіх осіб визначається умовами згоди суб'єкта персональних даних, наданої володільцю персональних даних на обробку цих даних, або відповідно до вимог закону.
                                </p>
                                <p className="modal__content--indent">
                                    6.2. Доступ до персональних даних третій особі не надається, якщо зазначена особа відмовляється взяти на себе зобов'язання щодо забезпечення виконання вимог Закону України «Про захист персональних даних» або неспроможна їх забезпечити.
                                </p>
                                <p className="modal__content--indent">
                                    6.3. Суб'єкт відносин, пов'язаних з персональними даними, подає запит щодо доступу (далі — запит) до персональних даних володільцю персональних даних.
                                </p>
                                <p className="modal__content--indent">
                                    6.4. У запиті зазначаються:
                                </p>
                                <p className="modal__content--indent">
                                    — прізвище, ім'я та по батькові, місце проживання (місце перебування) і реквізити документа, що посвідчує фізичну особу, яка подає запит (для фізичної особи — заявника);
                                </p>
                                <p className="modal__content--indent">
                                    — найменування, місцезнаходження юридичної особи, яка подає запит, посада, прізвище, ім'я та по батькові особи, яка засвідчує запит; підтвердження того, що зміст запиту відповідає повноваженням юридичної особи (для юридичної особи — заявника);
                                </p>
                                <p className="modal__content--indent">
                                    — відомості про базу персональних даних, стосовно якої подається запит, чи відомості про володільця чи розпорядника цієї бази персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — перелік персональних даних, що запитуються;
                                </p>
                                <p className="modal__content--indent">
                                    — мета та/або правові підстави для запиту.
                                </p>
                                <p className="modal__content--indent">
                                    6.5. Строк вивчення запиту на предмет його задоволення не може перевищувати десяти робочих днів з дня його надходження. Протягом цього строку володілець бази персональних даних доводить до відома особи, яка подає запит, що запит буде задоволене або відповідні персональні дані не підлягають наданню, із зазначенням підстави, визначеної у відповідному нормативно-правовому акті. Запит задовольняється протягом тридцяти календарних днів з дня його надходження, якщо інше не передбачено законом.
                                </p>
                                <p className="modal__content--indent">
                                    6.6. Відстрочення доступу до персональних даних третіх осіб допускається у разі, якщо необхідні дані не можуть бути надані протягом тридцяти календарних днів з дня надходження запиту. При цьому загальний термін вирішення питань, порушених у запиті, не може перевищувати сорока п'яти календарних днів.
                                </p>
                                <p className="modal__content--indent">
                                    6.7. Повідомлення про відстрочення доводиться до відома третьої особи, яка подала запит, у письмовій формі з роз'ясненням порядку оскарження такого рішення.
                                </p>
                                <p className="modal__content--indent">
                                    6.8. У повідомленні про відстрочення зазначаються:
                                </p>
                                <p className="modal__content--indent">
                                    — прізвище, ім'я та по батькові посадової особи;
                                </p>
                                <p className="modal__content--indent">
                                    — дата відправлення повідомлення;
                                </p>
                                <p className="modal__content--indent">
                                    — причина відстрочення;
                                </p>
                                <p className="modal__content--indent">
                                    — строк, протягом якого буде задоволено запит.
                                </p>
                                <p className="modal__content--indent">
                                    6.9. Відмова у доступі до персональних даних допускається, якщо доступ до них заборонено згідно із законом.
                                </p>
                                <p className="modal__content--indent">
                                    6.10. У повідомленні про відмову зазначаються:
                                </p>
                                <p className="modal__content--indent">
                                    — прізвище, ім'я, по батькові посадової особи, яка відмовляє у доступі;
                                </p>
                                <p className="modal__content--indent">
                                    — дата відправлення повідомлення;
                                </p>
                                <p className="modal__content--indent">
                                    — причина відмови.
                                </p>
                                <p className="modal__content--indent">
                                    6.11. Рішення про відстрочення або відмову із доступі до персональних даних може бути оскаржено до суду.
                                </p>
                            </div>
                            <div className="modal__content__inner">
                                <h4>7. Захист персональних даних: способи захисту, відповідальна особа, працівники, які безпосередньо здійснюють обробку та/або мають доступ до персональних даних у зв’язку з виконанням своїх службових обов’язків, строк зберігання персональних даних</h4>
                                <p className="modal__content--indent">
                                    7.1. Володільця бази персональних даних обладнано системними і програмно-технічними засобами та засобами зв’язку, які запобігають втратам, крадіжкам, несанкціонованому знищенню, викривленню, підробленню, копіюванню інформації і відповідають вимогам міжнародних та національних стандартів.
                                </p>
                                <p className="modal__content--indent">
                                    7.2. Відповідальна особа організовує роботу, пов’язану із захистом персональних даних при їх обробці, відповідно до закону. Відповідальна особа визначається наказом Володільця бази персональних даних.
                                </p>
                                <p className="modal__content--indent">
                                    7.3. Відповідальна особа зобов’язана:
                                </p>
                                <p className="modal__content--indent">
                                    — знати законодавство України в сфері захисту персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — розробити процедури доступу до персональних даних співробітників відповідно до їхніх професійних чи службових або трудових обов’язків;
                                </p>
                                <p className="modal__content--indent">
                                    — забезпечити виконання співробітниками Володільця бази персональних даних вимог законодавства України в сфері захисту персональних даних та внутрішніх документів, що регулюють діяльність Володільця бази персональних даних щодо обробки і захисту персональних даних у базах персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — розробити порядок (процедуру) внутрішнього контролю за дотриманням вимог законодавства України в сфері захисту персональних даних та внутрішніх документів, що регулюють діяльність Володільця бази персональних даних щодо обробки і захисту персональних даних у базах персональних даних, який, зокрема, повинен містити норми щодо періодичності здійснення такого контролю;

                                </p>
                                <p className="modal__content--indent">
                                    — повідомляти Володільця бази персональних даних про факти порушень співробітниками вимог законодавства України в сфері захисту персональних даних та внутрішніх документів, що регулюють діяльність Володільця бази персональних даних щодо обробки і захисту персональних даних у базах персональних даних у термін не пізніше одного робочого дня з моменту виявлення таких порушень;
                                </p>
                                <p className="modal__content--indent">
                                    — забезпечити зберігання документів, що підтверджують надання суб’єктом персональних даних згоди на обробку своїх персональних даних та повідомлення вказаного суб’єкта про його права.
                                </p>
                                <p className="modal__content--indent">
                                    7.4. З метою виконання своїх обов’язків відповідальна особа має право:
                                </p>
                                <p className="modal__content--indent">
                                    — отримувати необхідні документи, у тому числі накази й інші розпорядчі документи, видані Володільцем бази персональних даних, пов’язані із обробкою персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — робити копії з отриманих документів, у тому числі копії файлів, будь-яких записів, що зберігаються в локальних обчислювальних мережах і автономних комп’ютерних системах;
                                </p>
                                <p className="modal__content--indent">
                                    — брати участь в обговоренні виконуваних ним обов’язків організації роботи, пов’язаної із захистом персональних даних при їх обробці;
                                </p>
                                <p className="modal__content--indent">
                                    — вносити на розгляд пропозиції щодо покращення діяльності та вдосконалення методів роботи, подавати зауваження та варіанти усунення виявлених недоліків у процесі обробки персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — одержувати пояснення з питань здійснення обробки персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — підписувати та візувати документи в межах своєї компетенції.
                                </p>
                                <p className="modal__content--indent">
                                    7.5. Працівники, які безпосередньо здійснюють обробку та/або мають доступ до персональних даних у зв’язку з виконанням своїх службових (трудових) обов’язків зобов’язані дотримуватись вимог законодавства України в сфері захисту персональних даних та внутрішніх документів, щодо обробки і захисту персональних даних у базах персональних даних.
                                </p>
                                <p className="modal__content--indent">
                                    7.6. Працівники, що мають доступ до персональних даних, у тому числі, здійснюють їх обробку зобов’язані не допускати розголошення у будь-який спосіб персональних даних, які їм було довірено або які стали відомі у зв’язку з виконанням професійних чи службових або трудових обов’язків. Таке зобов’язання чинне після припинення ними діяльності, пов’язаної з персональними даними, крім випадків, установлених законом.
                                </p>
                                <p className="modal__content--indent">
                                    7.7.Особи, що мають доступ до персональних даних, у тому числі, здійснюють їх обробку у разі порушення ними вимог Закону України «Про захист персональних даних» несуть відповідальність згідно законодавства України.
                                </p>
                                <p className="modal__content--indent">
                                    7.8. Персональні дані не повинні зберігатися довше, ніж це необхідно для мети, для якої такі дані зберігаються, але у будь-якому разі не довше строку зберігання даних, визначеного згодою суб’єкта персональних даних на обробку цих даних.
                                </p>
                            </div>
                            <div className="modal__content__inner">
                                <h4>8. Права суб’єкта персональних даних</h4>
                                <p className="modal__content--indent">
                                    8.1. Суб'єкт персональних даних має право:
                                </p>
                                <p className="modal__content--indent">
                                    — знати про місцезнаходження бази персональних даних, яка містить його персональні дані, її призначення та найменування, місцезнаходження та/або місце проживання (перебування) володільця чи розпорядника цієї бази або дати відповідне доручення щодо отримання цієї інформації уповноваженим ним особам, крім випадків, встановлених законом;
                                </p>
                                <p className="modal__content--indent">
                                    — отримувати інформацію про умови надання доступу до персональних даних, зокрема інформацію про третіх осіб, яким передаються його персональні дані, що містяться у відповідній базі персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — на доступ до своїх персональних даних, що містяться у відповідній базі персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — отримувати не пізніш як за тридцять календарних днів з дня надходження запиту, крім випадків, передбачених законом, відповідь про те, чи зберігаються його персональні дані у відповідній базі персональних даних, а також отримувати зміст його персональних даних, які зберігаються;
                                </p>
                                <p className="modal__content--indent">
                                    — пред'являти вмотивовану вимогу із запереченням проти обробки своїх персональних даних органами державної влади, органами місцевого самоврядування при здійсненні їхніх повноважень, передбачених законом;
                                </p>
                                <p className="modal__content--indent">
                                    — пред'являти вмотивовану вимогу щодо зміни або знищення своїх персональних даних будь-яким володільцем та розпорядником цієї бази, якщо ці дані обробляються незаконно чи є недостовірними;
                                </p>
                                <p className="modal__content--indent">
                                    — на захист своїх персональних даних від незаконної обробки та випадкової втрати, знищення, пошкодження у зв'язку з умисним приховуванням, ненаданням чи несвоєчасним їх наданням, а також на захист від надання відомостей, що є недостовірними чи ганьблять честь, гідність та ділову репутацію фізичної особи;
                                </p>
                                <p className="modal__content--indent">
                                    — звертатися з питань захисту своїх прав щодо персональних даних до органів державної влади, органів місцевого самоврядування, до повноважень яких належить здійснення захисту персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — застосовувати засоби правового захисту в разі порушення законодавства про захист персональних даних.
                                </p>
                            </div>
                            <div className="modal__content__inner">
                                <h4>9. Порядок роботи з запитами суб’єкта персональних даних</h4>
                                <p className="modal__content--indent">
                                    9.1. Суб'єкт персональних даних має право на одержання будь-яких відомостей про себе у будь-якого суб'єкта відносин, пов'язаних з персональними даними, без зазначення мети запиту, крім випадків, установлених законом.
                                </p>
                                <p className="modal__content--indent">
                                    9.2. Доступ суб'єкта персональних даних до даних про себе здійснюється безоплатно.
                                </p>
                                <p className="modal__content--indent">
                                    9.3. Суб’єкт персональних даних подає запит щодо доступу (далі — запит) до персональних даних володільцю бази персональних даних.
                                </p>
                                <p className="modal__content--indent">
                                    У запиті зазначаються:
                                </p>
                                <p className="modal__content--indent">
                                    — прізвище, ім'я та по батькові, місце проживання (місце перебування) і реквізити документа, що посвідчує особу суб’єкта персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — інші відомості, що дають змогу ідентифікувати особу суб’єкта персональних даних;
                                </p>
                                <p className="modal__content--indent">
                                    — відомості про базу персональних даних, стосовно якої подається запит, чи відомості про володільця чи розпорядника цієї бази;
                                </p>
                                <p className="modal__content--indent">
                                    — перелік персональних даних, що запитуються.
                                </p>
                                <p className="modal__content--indent">
                                    9.4. Строк вивчення запиту на предмет його задоволення не може перевищувати десяти робочих днів з дня його надходження. Протягом цього строку володілець бази персональних даних доводить до відома суб’єкта персональних даних, що запит буде задоволене або відповідні персональні дані не підлягають наданню, із зазначенням підстави, визначеної у відповідному нормативно-правовому акті.
                                </p>
                                <p className="modal__content--indent">
                                    9.5. Запит задовольняється протягом тридцяти календарних днів з дня його надходження, якщо інше не передбачено законом.
                                </p>
                            </div>
                            <div className="modal__content__inner">
                                <h4>10. Державна реєстрація бази персональних даних</h4>
                                <p className="modal__content--indent">
                                    10.1. Державна реєстрація баз персональних даних здійснюється відповідно до статті 9 Закону України «Про захист персональних даних».
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
